import axiosInstance from './AxiosInstance';

const API_URL = '/forms';

export const getForms = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error in fetching form list', error);
    throw error;
  }
};

export const getFormForDashBoard = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/formlist`, data);
    return response.data;
  } catch (error) {
    console.error('Error in fetching form list for dashboard', error);
    throw error;
  }
};

export const getFormById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/view/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error in fetching form with id ${id}`, error);
    throw error;
  }
};

export const createForm = async (form) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/add`, form);
    return response.data;
  } catch (error) {
    console.error('Error in saving form ', error);
    throw error;
  }
};

export const updateForm = async (id, form) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...form });
    return response.data;
  } catch (error) {
    console.error(`Error updating form with id ${id}`, error);
    throw error;
  }
};

export const deleteForm = async (id) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
    return response.data;
  } catch (error) {
    console.error(`Error deleting form with id ${id}`, error);
    throw error;
  }
};

export const exportReport = async (email = '') => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/export/excel`,
      { email: email },
      { responseType: 'blob' }
    );
    return response.data;
  } catch (error) {
    console.error(`Error while exporting report`, error);
    throw error;
  }
};

export const exportCOIReport = async (year) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/coi-report`,
      { year, export: true },
      { responseType: 'blob' }
    );
    return response.data;
  } catch (error) {
    console.error(`Error while exporting COI report`, error);
    throw error;
  }
};

export const checkCOISubmission = async (email, year) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/check-coi`, { email, year });
    return response.data;
  } catch (error) {
    console.error(`Error checking COI submission`, error);
    throw error;
  }
};
